<template>
  <Layout>
    <div style="width:100%;margin-top:55px;">
      <q-card v-if="operationReports.length === 0 && !loading">
        <empty-value
          name="reports"
          style="background:#fff !important"
        ></empty-value>
      </q-card>
      <report v-else />
      <div class="loading-infinite" v-if="loading">
        <div>
          <q-spinner-facebook color="primary" size="40px" />
          <div class="text-grey-7">Loading</div>
        </div>
      </div>
      <add-report></add-report>
      <report-filter></report-filter>
      <remove-report></remove-report>
      <router-view></router-view>
    </div>
  </Layout>
</template>

<script>
import axios from "../axios";
import Layout from "../components/Layout";
import EmptyValue from "../components/EmptyValue";
import AddReport from "../components/AddReport";
import Report from "../components/Report";
import ReportFilter from "../components/ReportFilter";
import RemoveReport from "../components/RemoveReport";
export default {
  metaInfo() {
    return {
      title:
        "Reports that help managers to manage their day to day operations | FMS",
      meta: [
        {
          name: "description",
          content:
            "Reports that help managers to manage their day to day operations",
        },
        {
          property: "og:title",
          content: "Adjustment of Current Fleet information | FMS",
        },
        { property: "og:site_name", content: "FMS" },
        { property: "og:type", content: "website" },
        { name: "robots", content: "index,follow" },
      ],
    };
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    search: {
      get() {
        return this.$store.state.reports.search;
      },
      set(val) {
        this.$store.commit("reports/SET_SEARCH", val);
      },
    },
    status: {
      get() {
        return this.$store.state.reports.status;
      },
      set(val) {
        this.$store.commit("reports/SET_status", val);
      },
    },
    type: {
      get() {
        return this.$store.state.reports.type;
      },
      set(val) {
        this.$store.commit("reports/SET_TYPE", val);
      },
    },
    location_id: {
      get() {
        return this.$store.state.reports.location_id;
      },
      set(val) {
        this.$store.commit("reports/SET_LOCATION_ID", val);
      },
    },
    params() {
      return {
        type: this.type && this.type.value ? this.type.value : null,
        location_id: this.location_id.map((item) => item.id) || [],
        q: this.search !== "" && this.search !== "" ? this.search : null,
        status: this.status && this.status.value ? this.status.value : null,
      };
    },
    page: {
      get() {
        return this.$store.state.reports.page;
      },
      set(val) {
        this.$store.commit("reports/SET_PAGE", val);
      },
    },
    per() {
      return this.$store.state.reports.per;
    },
    lastPage: {
      get() {
        return this.$store.state.reports.lastPage;
      },
      set(val) {
        this.$store.commit("reports/SET_LAST_PAGE", val);
      },
    },
    operationReports: {
      get() {
        return this.$store.state.reports.operationReports;
      },
      set(val) {
        this.$store.commit("reports/SET_REPORTS", val);
      },
    },
  },
  async mounted() {
    setTimeout(() => {
      document
        .querySelector(".scroll")
        .addEventListener("scroll", this.scrollHandler);
    }, 500);
    // if (this.$store.state.reports.operationReports.length === 0)
    //   await this.reports();
  },
  watch: {
    params: {
      deep: true,
      handler(n, o) {
        this.page = 0;
        this.operationReports = [];
        this.lastPage = 2;
        this.reports();
      },
    },
  },
  destroyed() {
    document
      .querySelector(".scroll")
      .removeEventListener("scroll", this.scrollHandler);
  },
  methods: {
    scrollHandler(e) {
      const obj = e.target;
      if (obj.scrollTop >= obj.scrollHeight - obj.offsetHeight - 100) {
        if (this.operationReports.length !== 0 && !this.loading) {
          this.reports();
        }
      }
    },
    async reports() {
      const params = {
        type: this.type && this.type.value ? this.type.value : null,
        location_id: this.location_id.map((item) => item.id) || [],
        q: this.search,
        status: this.status && this.status.val ? this.status.val : null,
        page: ++this.page,
        per: this.per,
      };
      if (this.lastPage >= this.page) {
        try {
          this.loading = true;
          const { data } = await axios.get("tsd-analyses", { params });
          const { first, last } = data.pagination;
          if (this.page === 1) this.operationReports = data.items;
          else this.$store.commit("reports/REPORT_PUSHER", data.items);
          this.lastPage = last;
          this.loading = false;
        } catch (error) {
          this.loading = false;
        }
      }
    },
  },
  components: {
    Layout,
    EmptyValue,
    AddReport,
    Report,
    ReportFilter,
    RemoveReport,
  },
};
</script>
